// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xCommonUpdate } from "@conklin/App/Handlers/XNG/Common";
import { addToChainAfter, Handler } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchSetIsOpen,
} from "@insite/client-framework/Store/Components/StorePickupOverlay/Handlers/SetStorePickupOverlayIsOpen";

type HandlerType = Handler<{
    isOpen: boolean;
    showBranchesOnly?: boolean;
}>;

export const setStorePickUpOverlayExtraData: HandlerType = ({ dispatch, parameter: { showBranchesOnly } }) => {
    dispatch(xCommonUpdate({ key: "storePickUpOverlayExtraData", value: { showBranchesOnly } }));
};

addToChainAfter(chain, DispatchSetIsOpen, setStorePickUpOverlayExtraData);
